export const currencyConverterApiEndpoints = {
    CRYPTO_CURRENCIES: 'cryptocurrencies',
};
